import { render } from "./BaseChartPanel.vue?vue&type=template&id=53f737c6&ts=true"
import script from "./BaseChartPanel.vue?vue&type=script&lang=ts"
export * from "./BaseChartPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__